// src/config/plotConfigs/utrPeriodicityConfig.js

export const utrPeriodicityConfig = {
  sections: [
    {
      fields: [
        {
          id: "minread",
          label: "Min Read Length",
          type: "number",
          placeholder: "20",
          min: 1,
          max: 1000,
          tooltip: "The shortest read length included in the analysis.",
          width: 3,
          triggersSmartAdjustment: true, // Enable smart adjustment
        },
        {
          id: "maxread",
          label: "Max Read Length",
          type: "number",
          placeholder: "150",
          min: 1,
          max: 1000,
          tooltip: "The longest read length included in the analysis.",
          width: 3,
          triggersSmartAdjustment: true, // Enable smart adjustment
        },
        {
          id: "maxYVal",
          label: "Max Y Value",
          type: "text",
          placeholder: "Auto",
          tooltip:
            "Set the max value on the y-axis, this can be useful if creating a panel of plots and you want all plots to have the same scale. If left blank the y-axis max value will be selected automatically and may differ between plots. Y-axis values for these plots are percentages so this value should be <= 100.",
          width: 3,
        },
        {
          id: "tranSelection",
          label: "Transcripts",
          type: "radio",
          options: [
            { value: "prin_trans", label: "Principal" },
            { value: "all_trans", label: "All" },
            { value: "custom_trans", label: "Custom" },
          ],
          tooltip:
            "Use only principal transcripts, all transcripts or a custom list (enter a comma or space seperated list of transcript ID's in the input box).",
          width: 3,
        },
        {
          id: "customTranList",
          label: "Custom Transcript List",
          type: "textarea",
          placeholder: "Enter transcript IDs...",
          tooltip: "Enter custom transcript list when 'Custom' is selected",
          width: 12,
          rows: 3,
          showIf: (settings) => settings.tranSelection === "custom",
        },
        {
          id: "selectRtOnly",
          label: "Select only RT region",
          type: "checkbox",
          tooltip:
            "If checked instead of reads being taken from the entire 3'UTR, reads will only be taken from the readthrough region (RT),i.e the region between the annotated CDS stop and next inframe stop. If unchecked reads will be taken from the entire 3'UTR.",
          width: 6,
        },
        {
          id: "excludeRtStop",
          label: "Exclude RT stop",
          type: "checkbox",
          tooltip:
            "If checked the readthrough region stop codon will be excluded from calculations.",
          width: 6,
        },
        {
          id: "email",
          label: "Email notification",
          type: "checkbox",
          tooltip:
            "If checked an email notification will be sent to you once the job has completed. The email will contain a link to the results of this job.",
          width: 6,
        },
      ],
    },
  ],
};

export const utrPeriodicityDefaults = {
  minread: 20,
  maxread: 35,
  selectRtOnly: false,
  excludeRtStop: false,
  maxYVal: "",
  tranSelection: "prin_trans",
  customTranList: "",
  email: false,
};

export const utrPeriodicityValidation = {
  minread: { required: true, min: 1, max: 1000, label: "Min read length" },
  maxread: { required: true, min: 1, max: 1000, label: "Max read length" },
  custom: (value, allSettings) => {
    if (allSettings.minread >= allSettings.maxread) {
      return "Min read length must be less than max read length";
    }
    if (
      allSettings.tranSelection === "custom" &&
      !allSettings.customTranList.trim()
    ) {
      return "Please provide custom transcript list";
    }
    if (
      allSettings.maxYVal &&
      (isNaN(allSettings.maxYVal) || Number(allSettings.maxYVal) <= 0)
    ) {
      return "Max Y value must be a positive number";
    }
    return null;
  },
};
